module.exports = __webpack_public_path__ + "img/mainMenu-onlineOrder.4c21cc78.svg";